import i18n from "../i18n";

/**
 * How every enum value the API sends is shown: `labelFor("payment_method",
 * "cash")` → "Cash" / "نقداً".
 *
 * One list of kinds, each pointing at its dictionary in the locale files, so a
 * screen never prints a raw key ("cash", "card_present") and never needs its
 * own `t(\`…${value}\`)`. A value the dictionary does not know yet falls back
 * to a humanised form ("gift_card" → "Gift card"), never to the key itself.
 */
const KINDS = {
  payment_method: "transactions.method",
  payment_status: "transactions.status",
  refund_status: "enums.refundStatus",
  refund_reason: "transactions.reason",
  settlement_status: "transactions.settlement",
  checkout_payment_status: "checkout.paymentStatus",
  booking_status: "appointments.status",
  booking_source: "appointments.source",
  cancellation_actor: "enums.cancellationActor",
  stock_movement: "movementTypes",
  stock_state: "enums.stockState",
  loyalty_type: "loyalty.types",
  loyalty_reason: "loyalty.reasons",
  loyalty_source: "loyalty.sources",
  loyalty_mode: "loyalty.modes",
  loyalty_earn_on: "loyalty.earnOn",
  reward_type: "loyalty.rewardTypes",
  redemption_status: "enums.redemptionStatus",
  program_status: "loyalty.history.status",
  alert_type: "alerts.types",
  alert_severity: "alerts.severities",
  alert_status: "alerts.statuses",
  platform: "enums.platform",
  auth_provider: "enums.authProvider",
  tax_mode: "catalogue.taxModes",
  unit: "units",
  gender: "genders",
  branch_status: "branchStatus",
  employment_status: "providers.status",
  commission_type: "providers.commissionTypes",
  leave_type: "providers.leave.types",
  schedule_type: "providers.schedule.types",
  consent_purpose: "clients.consent.purposes",
  consent_channel: "clients.consent.channels",
  consent_source: "clients.consent.sources",
  note_visibility: "clients.notes.visibilities",
  timeline_source: "clients.timeline.source",
  report_series: "reports.shell.series",
  report_group: "reports.shell.groupBy",
  report_period: "reports.periods",
  report_compare: "reports.compare",
  date_basis: "reports.shell.dateBases",
};

/** "card_present" → "Card present": the last resort, still readable. */
export const humanise = (value) => {
  const text = String(value ?? "")
    .replace(/[_-]+/g, " ")
    .trim();

  return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
};

/** The label for one enum value; "" for none. */
export const labelFor = (kind, value) => {
  if (value === null || value === undefined || value === "") return "";

  const prefix = KINDS[kind] ?? `enums.${kind}`;

  return i18n.t(`${prefix}.${value}`, { defaultValue: humanise(value) });
};
